/** Shared helpers for white-label landing templates. */

export function mapPricingPlans(pricingPlans) {
  if (!pricingPlans?.length) return [];
  return pricingPlans.map((p) => ({
    key: p.key || '',
    name: p.name,
    price: p.price,
    period: '',
    desc: p.description || '',
    features: p.features || p.feature_notes || [],
    cta: p.cta || 'Get started',
    highlight: !!p.highlight,
    badge: p.highlight ? 'Most Popular' : undefined,
  }));
}

export function authPathWithPlan(authPath, planKey) {
  if (!planKey) return authPath;
  const sep = authPath.includes('?') ? '&' : '?';
  return `${authPath}${sep}plan=${encodeURIComponent(planKey)}`;
}
